import { observable, action, computed, makeObservable } from 'mobx';
import { Moment } from 'moment';

import FORMATS from 'jsx/constants/FORMATS';

import { Constructor } from './types';

export interface DateRange {
  readonly startDate?: null | Moment | undefined;
  readonly endDate?: null | Moment | undefined;
}

const DateRangeable = <T extends Constructor>(superclass: T) => {
  class DateRangeableClass extends superclass {
    constructor(...args: any[]) {
      super(...args);
      makeObservable(this);
    }

    @observable
    dateRange: DateRange = {
      startDate: null,
      endDate: null,
    };

    @computed
    get dateRangeObject() {
      return this.dateRange;
    }

    @computed
    get formattedDateRange() {
      const { startDate, endDate } = this.dateRange;
      const startDateFormatted = startDate
        ? startDate.format(FORMATS.date.numeric)
        : '';
      const endDateFormatted = endDate
        ? endDate.format(FORMATS.date.numeric)
        : '';
      return {
        startDate: startDateFormatted,
        endDate: endDateFormatted,
      };
    }

    @action
    setDateFilters = (dateRange: DateRange) => {
      this.dateRange = dateRange;
    };
  }

  return DateRangeableClass;
};

export default DateRangeable;
